var map = {
	"./en/common": 1807,
	"./en/common.json": 1807,
	"./en/seo": 63351,
	"./en/seo.json": 63351,
	"./en/unit": 3891,
	"./en/unit.json": 3891,
	"./it-IT/common": 82951,
	"./it-IT/common.json": 82951,
	"./it-IT/seo": 44358,
	"./it-IT/seo.json": 44358,
	"./it-IT/unit": 15233,
	"./it-IT/unit.json": 15233
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32750;